import { connect } from 'react-redux'
import Table from './Table'

import onChangeTable from './Handlers/onChangeTable'

const mapStateToProps = (state) => ({
  subOrders: state.screens.SubcontractorSubOrders.subOrders,
  fetching: state.screens.SubcontractorSubOrders.fetching,
  pagination: state.screens.SubcontractorSubOrders.pagination,
})

const actionCreators = {
  onChangeTable,
}

export default connect(mapStateToProps, actionCreators)(Table)
